import { extractObjectFromDataTable } from 'hooks/datatable';
import { EntityType } from 'UI/constants/entityTypes';

import { columns, outcomeColumns } from './activityColumns';

export const formatResponseActivityTable = response => {
  const formattedData = response.data.data.map(item => ({
    ...item,
    activityOutcomeComments: item?.outcomes[0]?.comments || null,
    activityOutcomeTitle: item?.outcomes[0]?.activityOutComeType?.title || null
  }));

  return { ...response, data: { ...response.data, data: formattedData } };
};

export const formatResponseJobOrderActivityTable = response => response;

export const getFinalActivityColumns = entity => {
  return entity === EntityType.Joborder ? columns : [...columns, ...outcomeColumns];
};

export const opsCanManage = ({ rowData }, tabData, initialColumns, isOperationUser) => {
  const { id } = extractObjectFromDataTable(initialColumns, ['id'], rowData);

  const selectedItem = tabData.find(item => item.id === id);

  const canManage = isOperationUser && !selectedItem.created_by_system;

  return canManage;
};
